import { IDeviceStreamConfiguration } from "@formant/core/model/IDeviceStreamConfiguration";
import { VideoQuality } from "@formant/core/model/VideoQuality";

export function minQualityForStreams(
    streams: IDeviceStreamConfiguration[],
): VideoQuality {
    return streams.reduce<VideoQuality>((min, stream) => {
        return !stream.quality
            ? "720p"
            : parseInt(min, 10) < parseInt(stream.quality, 10)
              ? min
              : stream.quality;
    }, "1080p");
}
